import { render, staticRenderFns } from "./research-group-list.html?vue&type=template&id=7a3871bc&scoped=true&"
import script from "./research-group-list.js?vue&type=script&lang=js&"
export * from "./research-group-list.js?vue&type=script&lang=js&"
import style0 from "./research-group-list.scss?vue&type=style&index=0&id=7a3871bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3871bc",
  null
  
)

export default component.exports